import React from 'react';
import './HamburgerMenu.css';

const HamburgerMenu = ({ open, onClose, onContact, onReportBug, menuCoords }) => {
    if (!open) return null;

    const menuStyle = menuCoords
        ? { position: 'fixed', top: `${menuCoords.top}px`, left: `${menuCoords.left}px` }
        : { position: 'fixed' };

    return (
        <>
            <div className="hamburger-overlay" onClick={onClose}></div>
            <div className="hamburger-menu" style={menuStyle}>
                <button className="menu-item" onClick={() => { onContact(); onClose(); }}>
                    Contact Us
                </button>
                <button className="menu-item" onClick={() => { onReportBug(); onClose(); }}>
                    Report a Bug
                </button>
            </div>
        </>
    );
};

export default HamburgerMenu;
